import React from "react";
import Layout from "../layout";
import LoginNavigationComponent from "./components/LoginNavigationComponent";
import LeadNavigationComponent from "./components/LeadNavigationComponent";


const ReferralCX = ({ step, setStep, token, setToken,response }) => {
  const urlParams = window.location.search || '';
  
  return (
    <div className="d-flex flex-column flex-root" id="kt_app_root" style={{ height: "100vh" }}>
      <div
        className="d-flex flex-column flex-lg-row flex-column-fluid stepper stepper-pills stepper-column stepper-multistep"
        id="kt_create_account_stepper"
      >
        <Layout />
        <div className="d-flex flex-column flex-lg-row-fluid py-10">
          <div className="d-flex flex-center flex-column flex-column-fluid">
            <div className="w-lg-650px w-xl-700px p-10 p-lg-15 mx-auto">

              {step === 1 ? (
                <LoginNavigationComponent step={step} queryString={urlParams} />
              ) : step === 2 ? (
                <LeadNavigationComponent step={step}/>
              ) : (
                    null
              )}
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralCX;
